<template>
  <div class="wrapper padding-sm">
    <div class="padding-bottom-xl">
      <router-link :to="'/expert/attendOrg/'+item.id" class="score-item" v-for="item in list" :key="item.id">
        <h3 class="margin-bottom-xs ovHide">{{ item.name }}</h3>
        <p>{{ item.year }}年</p>
      </router-link>
      <van-empty description="暂无数据" v-if="noData"/>
    </div>
    <van-tabbar v-model="active" >
      <van-tabbar-item replace to="/expert/scoreList" icon="todo-list">评估列表</van-tabbar-item>
      <van-tabbar-item replace to="/expert/user" icon="column">打分记录</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {getScoreList} from "@/api/expert";

export default {
  name: "scoreList",
  data() {
    return {
      active:0,
      list:[],
      noData:false,
    }
  },
  created() {
    this.$emit("setTabbar",true,0);
    this.getList()
  },
  components: {},
  methods: {
    async getList(){
      const res =await getScoreList()
      this.list = res.data
      if(this.list.length === 0) {
        this.noData = true
      }else {
        this.noData = false
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.wrapper{
  .score-item{
    display: block;
    width: 100%;
    height: 100px;
    padding: 20px;
    margin-bottom: 20px;
    background: url(../../../assets/mImg/score-item.png) no-repeat top right;
    background-size: 100%;
    h3{
      font-size: 18px;
      line-height: 150%;
      letter-spacing: 1px;
      color: #333333;
    }
    p{
      line-height: 150%;
      color: #666;
      font-size: 16px;
    }
  }
}
</style>
